/* import __COLOCATED_TEMPLATE__ from './address-input-type-form.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@ember/component';
import CountryAddressDataLocalizer from '@dashboard/shared-ui/utils/country-address-data-localizer';
let AddressInputTypeForm = (_dec = tagName(''), _dec2 = service('address'), _dec3 = computed('countryAddressData', 'i18n', 'labelOverrides'), _dec4 = computed('addressService', 'countryAddressData.format', 'useMarketUI', 'useNarrowLayout'), _dec(_class = (_class2 = class AddressInputTypeForm extends Component {
  constructor(...args) {
    super(...args);
    // passed-in
    _defineProperty(this, "address", null);
    _defineProperty(this, "countryAddressData", null);
    _defineProperty(this, "useNarrowLayout", false);
    _defineProperty(this, "validatedController", null);
    _defineProperty(this, "isReadOnly", false);
    _defineProperty(this, "labelOverrides", null);
    _defineProperty(this, "onAutocompleteItemSelected", null);
    // properties
    _initializerDefineProperty(this, "addressService", _descriptor, this);
    _defineProperty(this, "useMarketUI", true);
    _initializerDefineProperty(this, "i18n", _descriptor2, this);
  }
  get countryAddressDataLocalizer() {
    return new CountryAddressDataLocalizer(this.countryAddressData, this.i18n, this.labelOverrides);
  }
  get formatStructure() {
    if (isEmpty(this.countryAddressData?.format)) {
      return [];
    }
    if (this.useNarrowLayout) {
      return this.addressService.getCountryAddressFormatBasic(this.countryAddressData, this.useMarketUI);
    }
    return this.addressService.getCountryAddressFormatAdvanced(this.countryAddressData, this.useMarketUI);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "addressService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "countryAddressDataLocalizer", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "countryAddressDataLocalizer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formatStructure", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "formatStructure"), _class2.prototype), _class2)) || _class);
export { AddressInputTypeForm as default };